import { Rank, type EnemyDef } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   EB-4-g/d — LES DEUX CASEMATES DU BUNKER.

   Le premier des deux verrous du Bunker. Tant qu'une casemate vit, le noyau est
   scellé : les percer est la condition d'accès, pas une option. Un fichier pour
   les deux, car c'est leur DÉSYNCHRONISATION qui les rend franchissables.

   ── Pourquoi 340 PV chacune et pas moins ──
   680 PV de démontage devant 480 de corps : le premier verrou pèse plus lourd
   que le noyau lui-même. C'est voulu — la moitié « priorité » du combat doit
   durer assez pour être vécue comme une phase, sinon le Bunker se réduirait à
   « un cône avec deux verrues » et la première leçon passerait inaperçue. Le
   coût total reste franchissable parce qu'il BLOQUE : on ne l'ignore pas, donc on
   paie ce prix une fois, en connaissance de cause.

   ── Pourquoi deux natures ──
   Gauche visé, droit d'aire : comme les canons du Char, l'ordre de destruction
   a une conséquence lisible, et « quelle casemate d'abord » est précisément la
   question que la première moitié du combat pose. Deux casemates identiques
   auraient scellé le noyau sans rien apprendre.
   ═══════════════════════════════════════════════════════════════════════════ */

const BASE = {
  rank: Rank.Standard,
  hp: 340,
  visualRadius: 18,
  score: 260,
  telegraph: 1.1,
  drops: 1,
  // Repositionnée chaque tick sur son porteur : trajectoire propre jamais lue.
  motion: { kind: Motion.Anchor, speed: 0, holdY: 300 },
} as const;

const casemates: EnemyDef[] = [
  defineEnemy({
    ...BASE,
    id: 'bunker-casemate-g',
    emitter: {
      // La casemate VISÉE : elle suit le joueur pendant qu'il cherche à percer.
      pattern: Pattern.Aimed,
      every: 2.0,
      count: 2,
      spreadDeg: 14,
      speed: 430,
      firstDelay: 1.6,
      family: Fam.EnemyPink,
    },
  }),
  defineEnemy({
    ...BASE,
    id: 'bunker-casemate-d',
    emitter: {
      // La casemate d'AIRE : un éventail statique, décalé d'une demi-seconde de
      // la visée pour étaler la pression au lieu de la concentrer en une salve.
      pattern: Pattern.Fan,
      every: 2.0,
      count: 4,
      spreadDeg: 50,
      speed: 360,
      firstDelay: 2.1,
      family: Fam.EnemyPurple,
    },
  }),
];

export default casemates;
